import { render } from "./More.vue?vue&type=template&id=769bffcf&scoped=true"
import script from "./More.vue?vue&type=script&lang=js"
export * from "./More.vue?vue&type=script&lang=js"

import "./More.vue?vue&type=style&index=0&id=769bffcf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769bffcf"]])

export default __exports__